export enum CountryCode {
  EG = "EG",
  MA = "MA",
  LB = "LB",
  SA = "SA",
  AE = "AE",
  US = "US",
  KW = "KW",
}
